var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "woermaCouponCustomer" },
    [
      _c(
        "el-form",
        {
          staticClass: "form",
          attrs: { inline: true, disabled: !_vm.edit, "label-suffix": ":" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "270px" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "券类型中已包含商品分类限制，选中券类型可在限制品类中查看不支持品类；如需新增限制商品，请联系沃尔玛新建券类型",
                                placement: "bottom",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                                staticStyle: {
                                  "font-weight": "bold",
                                  cursor: "pointer",
                                  "font-size": "13px",
                                },
                              }),
                            ]
                          ),
                          _c("span", [
                            _vm._v("【沃尔玛自由兑】券类型（商品分类限制）"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.onChangeCouponTypeControl },
                          model: {
                            value: _vm.woerma_coupon_type_control,
                            callback: function ($$v) {
                              _vm.woerma_coupon_type_control = $$v
                            },
                            expression: "woerma_coupon_type_control",
                          },
                        },
                        _vm._l(_vm.controlOptions, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "270px" } },
                    [
                      _c("template", { slot: "label" }, [_c("span")]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.isCouponTypeDisabled,
                          },
                          model: {
                            value: _vm.coupon_type,
                            callback: function ($$v) {
                              _vm.coupon_type = $$v
                            },
                            expression: "coupon_type",
                          },
                        },
                        _vm._l(
                          _vm.couponConfig.couponTypeOptions,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                value: item.coupon_type,
                                label: item.name,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "限制品类", "label-width": "180px" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "270px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 6 },
                          disabled: "",
                          placeholder: "请选择券类型",
                        },
                        model: {
                          value: _vm.coupon_limit_cat,
                          callback: function ($$v) {
                            _vm.coupon_limit_cat = $$v
                          },
                          expression: "coupon_limit_cat",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "使用说明提示方式",
                        "label-width": "270px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.onChangeCouponDescriptionControl },
                          model: {
                            value: _vm.woerma_coupon_description_control,
                            callback: function ($$v) {
                              _vm.woerma_coupon_description_control = $$v
                            },
                            expression: "woerma_coupon_description_control",
                          },
                        },
                        _vm._l(_vm.controlOptions, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "提示信息内容", "label-width": "270px" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 5, maxRows: 8 },
                          placeholder: "请输入提示信息内容",
                          maxlength: "150",
                          "show-word-limit": "",
                          num: "",
                          disabled: _vm.isCouponDescriptionDisabled,
                        },
                        model: {
                          value: _vm.coupon_description,
                          callback: function ($$v) {
                            _vm.coupon_description = $$v
                          },
                          expression: "coupon_description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "位置示例图", "label-width": "180px" } },
                    [
                      _c(
                        "div",
                        { staticClass: "img-wrap" },
                        _vm._l(_vm.imgSrcList, function (img, index) {
                          return _c("el-image", {
                            key: index,
                            attrs: {
                              "z-index": 3000,
                              src: img,
                              "preview-src-list": _vm.imgSrcList,
                              fit: "scale-down",
                            },
                          })
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }